/**
 * Named authors for marketing content that carries a byline. Pages reference
 * an entry here so the visible byline and the schema.org Person stay in step;
 * blog posts still carry their author in frontmatter and should migrate to
 * this registry as the site-wide byline rollout reaches them.
 */
export interface Author {
	name: string;
	/** Site-relative path to a square headshot. */
	image: string;
	/** Profile URLs for schema.org `sameAs`. */
	sameAs: readonly string[];
}

export const AUTHORS = {
	jimWrubel: {
		name: "Jim Wrubel",
		image: "/images/blog/jwrubel_hs_square.webp",
		sameAs: [
			"https://www.linkedin.com/in/jwrubel/",
			"https://www.crunchbase.com/person/jim-wrubel-56d7",
		],
	},
} as const satisfies Record<string, Author>;
